import { Component } from '@angular/core';
import { UserService } from '../../services/user.service';
import { CellClickedEvent, ColDef } from '@ag-grid-community/core';
import { CreateUserComponent } from './create-user/create-user.component';
import { MatDialog } from '@angular/material/dialog';
import { EditUserComponent } from './edit-user/edit-user.component';
import { ProjectsService } from '../../services/projects.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent {
  openCreateUser: boolean = false;
  users: any[] = [];
  projects: any[] = [];
  user: any = {};
  colDefs: ColDef[] = [
    { field: "firstName" },
    { field: "lastName" },
    { field: "email" },
    { field: "externalId" },
    { field: "isActive" },
    {
      field: "lastLogin",
      filter: 'agDateColumnFilter',
      cellRenderer: (data: any) => { return data.value ? ((new Date(data.value)).toLocaleDateString() + ' ' + (new Date(data.value)).toLocaleTimeString()) : ''; },
      valueGetter: (data: any) => { return data.data.lastLogin ? new Date(data.data.lastLogin) : null; }
    }
  ];  
  userGridOptions = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
    },
    onCellClicked: this.onCellClicked.bind(this),
    paginationPageSize: 20,
  };
  modalRef: any | null = null;



  constructor(
    private readonly userService: UserService,
    private readonly dialog: MatDialog,
    private readonly projectService: ProjectsService,
    private readonly router: Router
  ) {
    this.userService.getAll().subscribe((_: any) => this.users = _.users);
    this.projectService.getProjects().subscribe((_: any) => {
      this.projects = _;
      this.updateUserProjects();
    });
  }
  dateFormatter(params: any) {
    return params.value ? (new Date(params.value)) : null;
  }
  onCellClicked(event: CellClickedEvent) {
    const selectedId = event.data['id'];
    this.userService.getUserPermissions(selectedId).subscribe(_ => {
      this.user = _;
      this.user.isActive = event.data['isActive'];
      this.updateUserProjects();
    });
  }
  updatePermissions(){ 
    var data = this.user.projects;
    data.forEach((_: any) => {
      if (!Array.isArray(_.roles)) {
        _.roles = _.roles.split(',');
      }
    });
    this.userService.updateUserPermissions(this.user.id, data).subscribe(_ => this.router.navigate([this.router.url]));
  }
  createUser() {
    this.openCreateUserModal().then(_ => {
      this.router.navigate([this.router.url]);
    });
  }
  edit(user: any) {
    this.openEditUserModal().then(_ => {
      this.userService.getAll().subscribe((_: any) => this.users = _.users);
      this.userService.getUserPermissions(this.user.id).subscribe(_ => {
        var isActive = this.user.isActive;
        this.user = _;
        this.user.isActive = isActive;
      });
    });
  }
  refresh(user: any) {
    this.userService.refreshExternalData(user.id).subscribe();
  }
  
  private openCreateUserModal(): Promise<string> {
    this.openCreateUser = true;
    return new Promise((resolve, reject) => {
      this.modalRef = this.dialog.open(CreateUserComponent);
      this.modalRef.afterClosed().subscribe((message: any) => {
        this.openCreateUser = false;
        if (message == 'save') { resolve(message); } else { reject(); }
      });
    });
  }
  private openEditUserModal(): Promise<string> {
    this.openCreateUser = true;
    return new Promise((resolve, reject) => {
      this.modalRef = this.dialog.open(EditUserComponent, { data: this.user });
      this.modalRef.afterClosed().subscribe((message: any) => {
        this.openCreateUser = false;
        if (message == 'save') { resolve(message); } else { reject(); }
      });
    });
  }
  private updateUserProjects() {
    if (!this.user || this.user?.projects == null) { return; }
    if (!this.projects) { return; }

    this.projects.forEach((project: any) => {
      if (this.user.projects.filter((_: any) => _.id == project.id).length < 1) {
        this.user.projects.push({'id': project.id, 'projectName': project.name, 'roles': []});
      }
    });
  }
}
